'use client';

import { jsonToHtml } from '@contentstack/json-rte-serializer';

// BL-650: the size-chart modal content is a JSON RTE table. The generic
// rte() helper (utils/rte.js) has no table handling, so this follows
// LargeTable.js's pattern of a custom serializer instead, rather than
// extending the shared one for one caller.
const tableSerializer = {
  customElementTypes: {
    table: (_attrs, child) => `<table class="w-full border-collapse mb-2">${child}</table>`,
    tr: (_attrs, child) => `<tr class="border-b border-sand">${child}</tr>`,
    th: (_attrs, child) =>
      `<th class="p-3 text-left align-middle text-sm font-semibold">${child}</th>`,
    td: (_attrs, child) => `<td class="p-3 text-left align-middle text-sm">${child}</td>`,
    p: (_attrs, child) => `<p class="mb-4 last:mb-0">${child}</p>`,
  },
};

const RteModal = ({ content }) => {
  if (!content) return null;
  const html = jsonToHtml(content, tableSerializer);
  if (!html) return null;

  return (
    <div
      className="rte-content rte-content--light px-6 py-10 sm:px-8 sm:py-12 lg:px-10 lg:py-8 font-worksans text-base leading-relaxed text-primary overflow-x-auto"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RteModal;
